import { useState } from "react";
import Slider from "../../../components/ui/Slider";
import Text from "../../../components/ui/Text";
import itemImage from "../assets/images/shop-item.png";
import dollarImage from "../assets/images/dollar.png";
import { truncString } from "../../walkie-talkie/helpers";
import cashImage from "../assets/images/cash.png";
import cardImage from "../assets/images/card.png";
import { useAudioEffects } from "../../../hooks/use-audio-effects";
import clickSound from "../../../assets/audio/click.wav";

interface Props {
  className?: string;
  title?: string;
}

type ShopItemType = {
  id: string;
  price: number;
  image: string;
  name: string;
};

const GasStationMarket = ({
  className = "",
  title = "Market of Gas Station",
}: Props) => {
  const [items, setItems] = useState<ShopItemType[]>([
    {
      id: "1",
      name: "Item Name fsafas fasf saf asf asfasf",
      image: itemImage,
      price: 690000,
    },
    {
      id: "2",
      name: "Sandwich",
      image: itemImage,
      price: 690000,
    },
    {
      id: "3",
      name: "Sandwich",
      image: itemImage,
      price: 690000,
    },
    {
      id: "4",
      name: "Sandwich",
      image: itemImage,
      price: 690000,
    },
    {
      id: "5",
      name: "Sandwich",
      image: itemImage,
      price: 690000,
    },
    {
      id: "6",
      name: "Sandwich",
      image: itemImage,
      price: 690000,
    },
    {
      id: "7",
      name: "Sandwich",
      image: itemImage,
      price: 690000,
    },
  ]);

  return (
    <div className={`${className}`}>
      {/** Heading */}
      <div className="flex items-center space-x-8">
        <div className="bg-white/25 h-[1px] w-full flex-1"></div>
        <Text className="text-white !font-[400] flex-2 bender-font" size="2xl">
          {title}
        </Text>
        <div className="bg-white/25 h-[1px] w-full flex-1"></div>
      </div>

      {/** Items */}
      <Slider>
        <div className="flex items-center space-x-3">
          {items?.map((item) => (
            <ShopItem key={item.id} item={item} />
          ))}
        </div>
      </Slider>

      {/** Price */}
      <div className="flex items-center space-x-3 mt-2">
        <div
          style={{
            backdropFilter: "blur(100px)",
            boxShadow: "rgba(158, 255, 35, 0.3) 0px 3px 16px 0px",
          }}
          className="p-3 px-4 bg-[#9EFF23]/20 max-w-fit rounded-sm"
        >
          <img
            src={dollarImage}
            alt="$"
            className="w-[13px] h-[19px] object-contain"
          />
        </div>

        <div className="relative flex items-center overflow-hidden justify-between w-full bg-[radial-gradient(circle,rgba(255,255,255,0.0250)_0%,rgba(255,255,255,0.01)_100%)] p-2 px-4  rounded-md border-[1px] border-r-white/5 border-l-white/5 border-t-white/15 border-b-0">
          <Text
            size="xl"
            className="text-white !font-semibold uppercase tracking-tight bender-font"
          >
            Total price
          </Text>
          <Price currency={"$"} price={690000} />
        </div>
      </div>

      {/** Buttons */}
      <div className="relative w-full bg-[radial-gradient(circle,rgba(255,255,255,0.0250)_0%,rgba(255,255,255,0.01)_100%)] p-3 px-4  rounded-md border-[1px] border-r-white/5 border-l-white/5 border-t-white/15 border-b-0 mt-5 grid grid-cols-2 gap-5">
        <PayButton variant="by-card" />

        <PayButton variant="by-cash" />
      </div>
    </div>
  );
};

export function ShopItem({
  item,
  className = "",
  currency = "$",
}: {
  className?: string;
  item: ShopItemType;
  currency?: string;
}) {
  // dodati cart funkcionalnost, style je li u korpi itd...
  return (
    <div
      className={`bg-[radial-gradient(circle,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.01)_100%)] p-3 rounded-md min-w-[176px] min-h-[150px] xl:min-h-[176px] relative flex items-center justify-between flex-col overflow-hidden ${className}`}
    >
      <div
        style={{
          background:
            "linear-gradient(to right, rgba(255,255,255,0.070) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.070) 100%)",
        }}
        className="absolute top-0 left-0 w-full h-[1.2px] z-[1]"
      ></div>
      <div
        style={{
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.070) 0%, rgba(255,255,255,0.050) 70%, rgba(255,255,255,0.0) 100%)",
        }}
        className="absolute left-0 bottom-0 w-[1.2px] h-full z-[1]"
      ></div>
      <div
        style={{
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.070) 0%, rgba(255,255,255,0.050) 70%, rgba(255,255,255,0.0) 100%)",
        }}
        className="absolute right-0 bottom-0 w-[1.2px] h-full z-[1]"
      ></div>

      <div className="flex justify-start w-full items-start">
        <Price currency={currency} price={item.price} />
      </div>
      <img
        src={item.image}
        alt="Shop item img"
        className="w-[85px] xl:w-[95px] h-[47px] mt-6 mb-3 object-contain"
      />
      <div className="min-h-[50px] flex justify-center items-center text-center">
        <Text
          size="sm"
          className="text-white bender-font !font-[400] text-wrap "
        >
          {truncString(item.name, 15)}
        </Text>
      </div>
    </div>
  );
}

function PayButton({
  className = "",
  variant,
  onClick,
}: {
  className?: string;
  variant: "by-cash" | "by-card";
  onClick?: () => void;
}) {
  const { playEffect } = useAudioEffects();
  const gradient = {
    "by-cash": `bg-[linear-gradient(to_bottom,#2f5d1a_0%,#3ba600_50%,#2f5d1a_100%)] hover:bg-[linear-gradient(to_bottom,#3e7a20_0%,#4fd122_50%,#3e7a20_100%)]
`,
    "by-card": `bg-[linear-gradient(to_bottom,#1f5f63_0%,#2cb2bb_50%,#1f5f63_100%)] hover:bg-[linear-gradient(to_bottom,#217075_0%,#35c6d1_50%,#217075_100%)]`,
  };

  return (
    <button
      onClick={() => {
        if (onClick) onClick();

        playEffect(clickSound);
      }}
      type="button"
      className={`rounded-sm p-3  transition-all duration-300 ease-in-out active:scale-95 relative ${gradient[variant]}
    ${className}
  `}
    >
      <img
        src={variant === "by-card" ? cardImage : cashImage}
        className={`w-full h-full object-contain max-w-[60px]  absolute top-[50%] translate-y-[-50%] left-[-15px] ${
          variant === "by-card" ? "max-h-[30px]" : "max-h-[45px] left-[-5px]"
        }`}
      />
      <Text className="text-white gilroy-font drop-shadow-xl" size="xs">
        {variant === "by-card" ? "Pay by card" : "Pay by Cash"}
      </Text>

      {/** Border gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden rounded-sm">
        <div
          className={`absolute top-0 left-0 w-full bg-gradient-to-r h-[1px]  ${
            variant === "by-card"
              ? "from-[#38EAF5]/50 to-[#38EAF5]/0"
              : "from-[#52FF00]/50 to-[#52FF00]/0"
          }`}
        ></div>
        <div
          className={`absolute bottom-0 left-0 w-full bg-gradient-to-r h-[1px] ${
            variant === "by-card"
              ? "from-[#38EAF5]/0 to-[#38EAF5]/50"
              : "from-[#52FF00]/0 to-[#52FF00]/50"
          } `}
        ></div>
        <div
          className={`absolute bottom-0 right-0 w-[1px] h-full bg-gradient-to-b ${
            variant === "by-card"
              ? "from-[#38EAF5]/0 to-[#38EAF5]/50"
              : "from-[#52FF00]/0 to-[#52FF00]/50"
          }`}
        ></div>
      </div>
    </button>
  );
}

function Price({ currency, price }: { currency: string; price: number }) {
  return (
    <div
      className="p-1 px-2 rounded-md w-fit text-[#9EFF23] bg-[#9EFF23]/15 gilroy-font text-[14px] !font-[500] tracking-wider"
      style={{
        boxShadow: "rgba(158, 255, 35, 0.2) 0px 7px 29px 0px",
      }}
    >
      {currency}
      {new Intl.NumberFormat("en-US").format(price)}
    </div>
  );
}

export default GasStationMarket;
